<template>
  <v-select
    v-if="!isLoading"
    :items="items"
    v-model="model"
    label="Currency"
    item-text="currency"
    item-value="id"
    :rules="rules"
  ></v-select>
</template>

<script>
export default {
  data() {
    return {
      model: this.value,
      mandatoryRules: [v => !!v || "This fiels is mandatory"],
      message: null,
      search: null,
      isLoading: false,
      items: []
    };
  },
  props: ["value", "disabled", "rules"],
  watch: {
    model() {
      this.$emit("input", this.model);
    },
  },
  mounted: function() {
    this.getCurrency();
  },
  methods: {
    getCurrency() {
      this.$store
        .dispatch("currencies/index", {})
        .then(({currencies}) => {
          this.items = currencies.data;
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>
